import { createStyles, Theme } from '@material-ui/core';
import { fade } from '@material-ui/core/styles/colorManipulator';

export default ({ spacing: { unit }, palette }: Theme) =>
  createStyles({
    showMoreWrapper: {
      display: 'flex',
      position: 'fixed',
      top: 56,
      left: 0,
      right: 0,
      bottom: 10,
      zIndex: 100,
      overflowY: 'hidden',
      borderRadius: 6,
    },
    showMoreWrapperDesktop: {
      top: 80,
      left: 24,
      right: 24,
      bottom: 34,
    },
    showMore: {
      flex: 1,
      background: palette.common.white,
      padding: unit * 3,
      overflowY: 'auto',
      animation: 'slideInLeft 1s',
    },
    expansionPanel: {
      marginBottom: unit * 2,
    },
    '@keyframes slideInLeft': {
      '0%': {
        transform: 'translateX(200px)',
      },
      '100%': {
        transform: 'translateX(0)',
      },
    },
    schedulerButton: {
      marginBottom: unit,
      backgroundColor: palette.common.white,
      '&:hover': {
        backgroundColor: fade(palette.common.white, 0.8),
      },
    },
  });
